import {React, _n} from 'pexui';
import { Link } from '../comps/uicomps';

export class ShowAllFAQs extends React.Component {

  constructor(props) {
    super(props);
    this.windowHandler = props.windowHandler;
  }

  displayAllFaqs() {
    if (!this.windowHandler)
        return;
        
    const seeAllDiv = this.windowHandler.document.getElementById('infw_faq_seeall');
    const faqItems = this.windowHandler.document.querySelectorAll('div.infw-faq-item');

    if (!seeAllDiv || !faqItems) 
        return;

    for(let faqIndex = 0; faqIndex < faqItems.length; faqIndex++) {
      const faqItem = faqItems.item(faqIndex);
      faqItem.style.display = 'block';
    }
    seeAllDiv.style.display = 'none';
  };

  render() {
    return (
        <div id="infw_faq_seeall" className="infw-faq-seeall">
            <Link className="a" 
                label={ _n('link_help.seeall.label') } 
                onClick={ () => this.displayAllFaqs() } 
            />
        </div>
    );
  }
};


// WEBPACK FOOTER //
// ./application/src/views/comps/ShowAllFAQs.jsx